import { render, staticRenderFns } from "./largeFanli.vue?vue&type=template&id=37b8ff30&scoped=true"
import script from "./largeFanli.vue?vue&type=script&lang=js"
export * from "./largeFanli.vue?vue&type=script&lang=js"
import style0 from "./largeFanli.vue?vue&type=style&index=0&id=37b8ff30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8ff30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b8ff30')) {
      api.createRecord('37b8ff30', component.options)
    } else {
      api.reload('37b8ff30', component.options)
    }
    module.hot.accept("./largeFanli.vue?vue&type=template&id=37b8ff30&scoped=true", function () {
      api.rerender('37b8ff30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeFanli.vue"
export default component.exports